import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';

import Caption from '../../typography/Caption';

import './TaraText.css';

const Container = glamorous.div(({ theme, ...props }) => ({
  alignSelf: 'flex-start',
  position: 'relative',
  padding: '12px 16px',

  ...Caption.rules,

  marginBottom: props.isQuestion ? 32 : undefined,

  backgroundColor: theme.default.lightest,
  color: theme.primary.base,

  borderBottomRightRadius: 16,
  borderTopRightRadius: 16,
  borderBottomLeftRadius: 16,

  whiteSpace: 'pre-line',

  animationDelay: props.hasNoDelay ? undefined : '800ms',
  transformOriginX: 0,
  transformOriginY: 0,

  '&:before': {
    // CSS Triangle
    content: '""',
    position: 'absolute',
    left: props.isQuestion ? 0 : -15,
    top: props.isQuestion ? -15 : 0,
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: props.isQuestion ? '16px 0 0 16px' : '0 16px 16px 0',
    borderColor: props.isQuestion ? `transparent transparent transparent ${theme.default.lightest}` : `transparent ${theme.default.lightest} transparent transparent`,
  },
}));


class TaraText extends React.PureComponent {
  static propTypes = {
    hasNoDelay: PropTypes.bool,
    isAnimated: PropTypes.bool,
    isQuestion: PropTypes.bool,
  };

  static defaultProps = {
    hasNoDelay: false,
    isAnimated: false,
    isQuestion: false,
  };

  render() {
    const {
      isQuestion,
      isAnimated,
      className,
      ...rest
    } = this.props;

    return (
      <Container
        isQuestion={isQuestion}
        className={isAnimated ? `${className} TaraText--scaleIn` : className}
        {...rest}
      >
        {this.props.children}
      </Container>
    );
  }
}

export default TaraText;



// WEBPACK FOOTER //
// ./src/components/features/Tara/TaraText.js